import type { GuideStep } from "./types.js";
export const STEPS: readonly [GuideStep, ...GuideStep[]] = [
  {
    label: "Bring your music",
    title: "Good taste. Meet good company.",
    copy: "Choose audio files or a folder from your computer, phone or connected USB drive. Crate keeps a local copy and reads the song details already in your files.",
    note: "MP3 · FLAC · WAV · MP4 / M4A · Ogg · AIFF",
    action: "Add music",
    key: "add",
    visual: "import",
    stamp: "THE COLLECTION",
    detail: "Your files. A new home.",
  },
  {
    label: "Make it yours",
    title: "A little care for your collection.",
    copy: "Open a song’s ··· menu to edit its details and cover art. Missing BPM and key can be estimated on your device. Review the results, then save your changes into Crate’s audio copy.",
    note: "Your separate source files stay unchanged. Playback depends on your device’s codecs.",
    action: "Explore your library",
    key: "library",
    visual: "tags",
    stamp: "THE DETAILS",
    detail: "Every track, in its place.",
  },
  {
    label: "Find your flow",
    title: "Start with a feeling. Build a set.",
    copy: "Give your set a name, a mood and a cover. Pick songs from your library, then arrange them in the order that feels right. The same song can belong to more than one set.",
    note: "A warm-up. An afterparty. Something just for you.",
    action: "Create a set",
    key: "create",
    visual: "set",
    stamp: "THE SELECTION",
    detail: "One mood. Many possibilities.",
  },
  {
    label: "Keep it moving",
    title: "Take the music. Keep a copy.",
    copy: "Save a song list or export the actual music files. To move your whole collection, make a full backup ZIP with your audio, tags, artwork, favorites and sets, then restore it in Crate on the other device.",
    note: "Libraries are separate. There’s no account or automatic sync.",
    action: "Back up & restore",
    key: "backup",
    visual: "backup",
    stamp: "THE NEXT CHAPTER",
    detail: "Your next set goes with you.",
  },
];
export const FAQS: ReadonlyArray<readonly [string, string]> = [
  [
    "Where does my music live?",
    "In this browser, on this device. Imported songs are stored locally; they are not uploaded to Crate’s hosting. Clearing site data can remove your library, so save a full backup somewhere else too. The native iPhone app keeps its own app-owned files.",
  ],
  [
    "Can I use Crate offline?",
    "After the web app has loaded and cached its app shell, imported music, sets and editing tools work offline. The included demo needs to download once. Playback depends on the audio formats your browser supports.",
  ],
  [
    "How do I move between my computer and iPhone?",
    "Save a full backup ZIP, transfer it through Files, AirDrop or a USB drive, and restore that unchanged ZIP in Crate on the other device. Browser, Home Screen and native iPhone libraries are separate and do not automatically sync. Full backups must be under 4 GB.",
  ],
  [
    "Does sharing a list include the audio?",
    "A shared song list contains song details, not music files. Choose an audio ZIP when you want the actual music. Use a full backup to preserve your complete collection, favorites and sets.",
  ],
  [
    "How do I install the web app?",
    "On iPhone, open Crate in Safari, tap Share, then Add to Home Screen. On Android, use Install app or Add to Home screen in your browser menu. Keep a full backup before moving between installations.",
  ],
  [
    "Is Crate a DJ mixer?",
    "Crate helps you collect, edit, arrange and listen to your music. It plays tracks with play, pause, seek and skip controls. Live mixing, beatmatching and transitions are not included.",
  ],
];
